export interface BdLoaderOptions {
  type: 'loader-circle';
}

/**
 * `width`: The width of the loading animation circle.
 *          The surrounding container fills the parent width and the circle is centered inside.
 *          Default: '100px'
 */
export interface BdLoaderCircleOptions extends BdLoaderOptions {
  width?: string;
}

export const BD_LOADER_CIRCLE_OPTIONS_DEFAULT: BdLoaderCircleOptions = {
  type: 'loader-circle',
  width: '100px'
};

export const BD_LOADER_OPTIONS_DEFAULT = BD_LOADER_CIRCLE_OPTIONS_DEFAULT;
